import { action, computed, observable } from 'mobx';
import * as validator from 'validator';

import { InputHighlight, JobHistory } from '../types';

class JobHistoryEditorStore {
  private static _instance: JobHistoryEditorStore;

  @observable public awaitServer: boolean = false;
  @observable public category: string =  '';
  @observable public categoryBlurred: boolean =  false;
  @observable public edittingBlockId: number = 0;
  @observable public isEditModalActive: boolean = false
  @observable public jobs: JobHistory[] = [];
  @observable public level: string = '';
  @observable public levelBlurred: boolean =  false;
  @observable public title: string =  '';
  @observable public titleBlurred: boolean =  false;
  @observable public years: number =  0;
  @observable public yearsBlurred: boolean =  false;

  /**
   * Use JobHistoryStore.instance to retrieve an instance of this class.
   */
  private constructor() { }

  /**
   * Instance of JobHistoryStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new JobHistoryEditorStore();
    }

    return this._instance;
  }

  @computed
  public get isCategoryValid(): boolean {
    return this.categoryBlurred ? !validator.isEmpty(this.category) : true;
  }

  @computed
  public get categoryHelpMessage(): string {
    return this.isCategoryValid ? '' : 'Please enter job category';
  }

  @computed
  public get categoryHighlight(): InputHighlight {
    return this.isCategoryValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isLevelValid(): boolean {
    return this.levelBlurred ? !validator.isEmpty(this.level) : true;
  }

  @computed
  public get levelHelpMessage(): string {
    return this.isLevelValid ? '' : `Please select job level`;
  }

  @computed
  public get levelHighlight(): InputHighlight {
    return this.isLevelValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isTitleValid(): boolean {
    return this.titleBlurred ? !validator.isEmpty(this.title) : true;
  }

  @computed
  public get titleHelpMessage(): string {
    return this.isTitleValid ? '' : 'Please enter job title';
  }

  @computed
  public get titleHighlight(): InputHighlight {
    return this.isTitleValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isYearsValid(): boolean {
    return this.yearsBlurred
        ? this.years > 0 && this.years <= 100
        : true;
  }

  @computed
  public get yearsHelpMessage(): string {
    return this.isYearsValid ? '' : 'Must be between 1 - 100';
  }

  @computed
  public get yearsHighlight(): InputHighlight {
    return this.isYearsValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @action
  public checkReadyForSave = (): boolean => {
    this.categoryBlurred = true;
    this.levelBlurred = true;
    this.titleBlurred = true;
    this.yearsBlurred = true;
    return this.isCategoryValid && this.isLevelValid && this.isTitleValid && this.isYearsValid;
  }
}

export default JobHistoryEditorStore;
export const jobHistoryEditorStore = JobHistoryEditorStore.instance;


// WEBPACK FOOTER //
// ./src/stores/JobHistoryEditorStore.ts